import { render, staticRenderFns } from "./import-data.vue?vue&type=template&id=5f866fd2&"
import script from "./import-data.vue?vue&type=script&lang=js&"
export * from "./import-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f866fd2')) {
      api.createRecord('5f866fd2', component.options)
    } else {
      api.reload('5f866fd2', component.options)
    }
    module.hot.accept("./import-data.vue?vue&type=template&id=5f866fd2&", function () {
      api.rerender('5f866fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/import-data.vue"
export default component.exports